import Toastr from "../../../../itrust_common/components/Toastr";


const DEFAULT_STATE = {
  integrated_devices: [],
  integrated_device: {},
  meta: { pagination: {} },
  saving: false,
  editing: false
}

let changes = null;
export function integratedDevicesReducer(state = DEFAULT_STATE, action) {
  const response = action.payload && (action.payload.data || action.payload.response)
  let devices = [];
  let deviceData = [];
  let updatedRecord = {};

  switch (action.type) {
    case `INTEGRATED_DEVICES_CREATE_PENDING`:
    case `INTEGRATED_DEVICES_UPDATE_PENDING`:
    case `INTEGRATED_DEVICES_DELETE_PENDING`:
      return { ...state, saving: true };

    case `INTEGRATED_DEVICES_LOAD_REJECTED`:
    case `INTEGRATED_DEVICE_LOAD_REJECTED`:
    case `INTEGRATED_DEVICE_CREATE_REJECTED`:
    case `INTEGRATED_DEVICE_UPDATE_REJECTED`:
    case `INTEGRATED_DEVICE_DELETE_REJECTED`:
      Toastr.handleShow(response.data.success, response.data.error, response.status_code)
      changes = {
        saving: false
      }
      return { ...state, ...changes };

    case `INTEGRATED_DEVICES_LOAD_FULFILLED`:
      changes = {
        meta: response.meta,
        integrated_devices: response.integrated_devices || [],
        saving: false
      };
      return { ...state, ...changes };

    case `INTEGRATED_DEVICE_CREATE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      devices = [...state.integrated_devices]
      let newRecord = response.integrated_device
      changes = {
        integrated_devices: [newRecord, ...devices],
        editing: false,
        saving: false
      }
      return { ...state, ...changes };

    case `INTEGRATED_DEVICE_UPDATE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      devices = [...state.integrated_devices];
      updatedRecord = response.integrated_device;
      for (const [index, key] of devices.entries()) {
        if (key.id === updatedRecord.id) {
          deviceData = [
            ...devices.slice(0, index),
            updatedRecord,
            ...devices.slice(index + 1)
          ];
        }
      }
      changes = {
        integrated_devices: deviceData.length ? deviceData : [updatedRecord, ...devices],
        saving: false
      };
      return { ...state, ...changes };

    case `INTEGRATED_DEVICE_DELETE_FULFILLED`:
      Toastr.handleShow(true, response.meta.message, 201)
      devices = [...state.integrated_devices];
      for (const [index, key] of devices.entries()) {
        if (key.id === response.integrated_device.id) {
          devices.splice(index, 1);
        }
      }
      return {
        ...state,
        integrated_devices: devices,
      };

    case `INTEGRATED_DEVICE_EDIT`:
      changes = {
        editing: action.data,
      };
      return { ...state, ...changes };

    case `INTEGRATED_DEVICE_EDIT_CANCEL`:
      changes = {
        editing: false,
        integrated_device: {}
      };
      return { ...state, ...changes };

    default:
      return state;
  }
}
